import { createContext } from 'react';

const MealContext = createContext();

export default MealContext
 